import { ProductPutSchema } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import { Field, Formik } from "formik";
import { useProductTable } from "Hooks/Endpoints";
import React from "react";
import { Button, Card, Container, Form } from "semantic-ui-react";
import ProductTypeSelect from "./ProductTypeSelect";

const ProductForm = () => {
  const {
    product,
    updateProduct,
    unselectProduct,
    removeProduct,
  } = useProductTable();
  return (
    <Container fluid style={{ padding: "20px" }}>
      <Card fluid>
        <Card.Content>
          <Formik
            validateOnChange={false}
            initialValues={product}
            validationSchema={ProductPutSchema}
            onSubmit={(values, actions) => {
              updateProduct(values);
            }}
          >
            {({ handleSubmit, errors, validateField }) => (
              <Form onSubmit={handleSubmit}>
                <Field name='name' label='Name' component={CallableInput} />
                <Field
                  name='description'
                  label='Description'
                  component={CallableInput}
                />
                <Field
                  name='category'
                  label='Category'
                  component={CallableInput}
                />
                <ProductTypeSelect name='type' label='Product Type' />
                <Field name='price' label='Price' component={CallableInput} />
                <FormSubmit
                  name='Update'
                  errors={errors}
                  onCancel={() => unselectProduct()}
                />
                <Button
                  color='red'
                  onClick={() => removeProduct(product.id)}
                  icon='trash'
                />
              </Form>
            )}
          </Formik>
        </Card.Content>
      </Card>
    </Container>
  );
};

export default ProductForm;
